export enum DiagnosisType {
    INTERNAL = 'internal',
    EXTERNAL = 'external',
}
